module.exports = __webpack_public_path__ + "img/石韦.a86e2aac.jpg";